import { fetchAuthSession } from 'aws-amplify/auth';

export async function fetchCurrentUserData() {
  console.log("Fetching current user data", await fetchAuthSession());
  const { tokens } = await fetchAuthSession();
  const {
    // idToken,
    accessToken
  } = tokens;
  return accessToken.toString();
}

export async function customFetch(url, method, body){
    let accessToken = await fetchCurrentUserData();
    try{
        return fetch(url, {
            method: `${method}`,
            headers: {'Content-Type': 'application/json', 'accesstoken': `${accessToken}`},
            body: body
        })
            .then(res => res.json()
                .then(data => { return data })
            )
    } catch(e)
    {
        console.log(e)
    }

}

export async function customFetch_POST(url, body){
    let accessToken = await fetchCurrentUserData();
    try{
        return fetch(url, {
            method: `POST`,
            headers: {'Content-Type': 'application/json', 'accesstoken': `${accessToken}`},
            body: body
        })
            .then(res => res.json()
                .then(data => { return data })
            )
    } catch(e)
    {
        console.log(e)
    }

}

export async function customFetch_PUT(url, body){
    let accessToken = await fetchCurrentUserData();
    try {
        return fetch(url, {
            method: `PUT`,
            headers: {'Content-Type': 'application/json', 'accesstoken': `${accessToken}`},
            body: JSON.stringify(body)
        })
            .then(res => res.json()
                .then(data => { return data })
            )
    } catch(e)
    {
        console.log(e)
    }
}